import { ResourceAnalysis } from "../components/resource-analysis";
import { DocumentsSection } from "../components/side-panel-sections/documents-section";
import { SidePanelLayout } from "../components/side-panel-sections/side-panel-layout";
import { CarePlanRowData } from "../tables/care-plan";

export type CarePlanSidePanelContentProps = {
  data: CarePlanRowData;
};

export function CarePlanSidePanelContent({ data }: CarePlanSidePanelContentProps) {
  const dateRange = data.rawEndDate
    ? `${data.date} to ${data.rawEndDate.format("YYYY-MM-DD")}`
    : data.date;

  return (
    <SidePanelLayout title="Care Plan" subtitle={data.description} metadata={dateRange}>
      <ResourceAnalysis />

      <DocumentsSection resources={[data.originalData]} resourceType="CarePlan" />
    </SidePanelLayout>
  );
}
